import BaseLayout from '../../components/BaseLayout/BaseLayout';

export default function withBaseLayout(Component, layoutProps) {
  return (props) => (
    <BaseLayout grey={!!layoutProps?.grey}>
      <Component {...props} />
    </BaseLayout>
  );
}
